import { Injectable } from '@angular/core';
import { SessionService } from '../session/session.service';
import { Http } from '@angular/http';
import { Drawing } from '../../domain/drawing';
import { GameInfo } from '../../domain/signals/game-info';
import { DrawingService } from '../drawing/drawing.service';

@Injectable()
export class DrawingHistoryService {

  constructor(public sessionService: SessionService,
              public drawingService: DrawingService,
              public http: Http) {
  }

  setDrawingHistory(gameInfo: GameInfo) {
    if (gameInfo.State === GameInfo.States.DRAWING_HISTORY && gameInfo.LastResults.length > 0) {
      this.sessionService.drawings = gameInfo.LastResults.map(lr => {
        return new Drawing(lr.GameDate, this.drawingService.generateBalls(lr.Drawn, lr.Extra), lr.BingoGameID);
      });
    } else {
      this.sessionService.drawings = [];
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/services/drawing-history/drawing-history.service.ts